// @ts-nocheck
import { Dialog, Transition } from '@headlessui/react';
import { BanknotesIcon, XMarkIcon } from '@heroicons/react/24/outline';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSquarePlus } from '@fortawesome/free-solid-svg-icons';
import React, { Fragment, useCallback, useRef, useState } from 'react';
import CreateRate from './CreateRate';

export const RateModal = ({ onRateSaved }) => {
    const [isOpen, setIsOpen] = useState(false);
    const cancelButtonRef = useRef(null);

    const handleClickOpen = () => {
        setIsOpen(true);
    };

    const handleClose = useCallback(() => {
        setIsOpen(false);
    }, []);

    const handleSuccess = (updatedRates) => {
        handleClose();
        onRateSaved?.(updatedRates);
    };

    const buttonStyles = {
        cancel: 'inline-flex min-h-[46px] items-center justify-center rounded-xl border border-gray-200 bg-white px-5 text-sm font-bold text-gray-700 shadow-sm transition hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-green-cl focus:ring-offset-2',
        submit: 'inline-flex min-h-[46px] items-center justify-center rounded-xl bg-green-cl px-5 text-sm font-bold text-white shadow-sm transition hover:-translate-y-0.5 hover:bg-green-900 hover:shadow-md focus:outline-none focus:ring-2 focus:ring-green-cl focus:ring-offset-2',
    };

    const button2 = (
        <button
            type="button"
            className={buttonStyles.cancel}
            onClick={handleClose}
            ref={cancelButtonRef}
        >
            Cancelar
        </button>
    );

    const button1 = (
        <button
            type="submit"
            className={buttonStyles.submit}
        >
            Criar/Atualizar
        </button>
    );

    return (
        <>
            <button
                onClick={handleClickOpen}
                className="flex min-h-[168px] w-full cursor-pointer flex-col items-center justify-center overflow-hidden rounded-2xl border border-dashed border-green-cl/30 bg-emerald-50/30 p-6 text-center shadow-sm transition duration-200 hover:-translate-y-0.5 hover:border-green-cl/50 hover:bg-emerald-50/60 hover:shadow-md"
            >
                <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-green-cl text-white shadow-sm">
                    <FontAwesomeIcon icon={faSquarePlus} className="h-5 w-5" />
                </span>
                <p className="mt-3 text-lg font-bold text-gray-700">Sem taxas disponíveis</p>
                <p className="mt-1 max-w-sm text-sm text-gray-500">
                    Adicione a primeira taxa para começar a configurar este parceiro.
                </p>
            </button>

            <Transition.Root show={isOpen} as={Fragment}>
                <Dialog as="div" className="relative z-50" initialFocus={cancelButtonRef} onClose={handleClose}>
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-200"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-150"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div className="fixed inset-0 bg-gray-950/45 backdrop-blur-[2px]" />
                    </Transition.Child>

                    <div className="fixed inset-0 z-50 overflow-y-auto">
                        <div className="flex min-h-full items-center justify-center p-4 sm:p-6">
                            <Transition.Child
                                as={Fragment}
                                enter="ease-out duration-200"
                                enterFrom="opacity-0 translate-y-3 scale-95"
                                enterTo="opacity-100 translate-y-0 scale-100"
                                leave="ease-in duration-150"
                                leaveFrom="opacity-100 translate-y-0 scale-100"
                                leaveTo="opacity-0 translate-y-3 scale-95"
                            >
                                <Dialog.Panel className="w-full max-w-2xl overflow-visible rounded-3xl border border-white/70 bg-white text-left shadow-2xl">
                                    <div className="flex items-start justify-between border-b border-gray-100 px-6 py-5 sm:px-8 sm:py-6">
                                        <div className="flex items-start gap-4">
                                            <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl bg-emerald-50 text-green-cl ring-1 ring-emerald-100">
                                                <BanknotesIcon className="h-6 w-6" />
                                            </span>
                                            <div>
                                                <Dialog.Title as="h3" className="text-xl font-extrabold text-gray-900">
                                                    Criar/Atualizar taxa
                                                </Dialog.Title>
                                                <p className="mt-1 text-sm leading-5 text-gray-500">
                                                    Selecione o método de pagamento, o tipo de taxa e configure os respetivos valores.
                                                </p>
                                            </div>
                                        </div>
                                        <button
                                            type="button"
                                            onClick={handleClose}
                                            className="ml-4 rounded-xl p-2 text-gray-400 transition hover:bg-gray-100 hover:text-gray-700 focus:outline-none focus:ring-2 focus:ring-green-cl"
                                            aria-label="Fechar"
                                        >
                                            <XMarkIcon className="h-5 w-5" />
                                        </button>
                                    </div>

                                    <div className="px-6 py-6 sm:px-8">
                                        <CreateRate button1={button1} button2={button2} onSuccess={handleSuccess} />
                                    </div>
                                </Dialog.Panel>
                            </Transition.Child>
                        </div>
                    </div>
                </Dialog>
            </Transition.Root>
        </>
    );
};

export default RateModal;
